const slug = [
  "/wohngemeinschaft-demenz-nuernberg",
  "/tagespflege-nuernberg",
  "/ambulante-pflege-nuernberg",
  "/team-spaetsommer",
  "/pflegefachkraft-nuernberg",
]

export const topicSlug = {
  "voraussetzungen-und-leistungen-der-pflegegrade":
    "/themen-der-pflege/voraussetzungen-und-leistungen-der-pflegegrade",
  "moeglichkeiten-zur-finanziellen-unterstuetzung-und-leistungen-fuer-die-pflege-im-gewohnten-umfeld":
    "/themen-der-pflege/moeglichkeiten-zur-finanziellen-unterstuetzung-und-leistungen-fuer-die-pflege-im-gewohnten-umfeld",
}

export default slug
